<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="6">
        <evaluado-info-card-component :expediente="expediente[0]" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card
          class="card"
          color="primary"
        >
          <v-card-title class="font-weight-bold justify-center">
            Diagnóstico ISE
          </v-card-title>
          <v-card-text>
            <v-container class="mb-4">
              <v-row
                align="center"
                justify="center"
              >
                <v-col align="right">
                  <v-progress-circular
                    :value="activeStep * 20"
                    v-bind="circularProgressProps"
                  />
                </v-col>
                <v-col>
                  <div class="text-caption text--primary">
                    PASO {{ activeStep }}
                  </div>
                  <div class="text-subtitle-1 font-weight-bold text--primary">
                    {{ activeStepTitle }}
                  </div>
                  <a
                    v-show="activeStep !== 1"
                    class="text-decoration-none secondary--text"
                    @click="activeStep--"
                    @keydown="activeStep--"
                  >Volver al paso anterior</a>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-if="activeStep === 1">
              <v-form v-model="evaluadorForm">
                <v-row justify="center">
                  <v-col>
                    <v-select
                      v-model="ise.fk_idEvaluador"
                      label="Evaluador"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="evaluadores"
                      item-value="idEvaluador"
                      item-text="evaluador"
                      :rules="nameRules"
                    />
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="ise.fk_idSupervisor"
                      label="Supervisor"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="evaluadores"
                      item-value="idEvaluador"
                      item-text="evaluador"
                      :rules="nameRules"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container
              v-else-if="activeStep === 2"
              fluid
            >
              <v-form v-model="funcionesForm">
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="ise.funciones"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Funciones"
                      no-resize
                      rows="12"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container
              v-else-if="activeStep === 3"
              fluid
            >
              <v-form v-model="analisisForm">
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="ise.analisis"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Análisis"
                      no-resize
                      rows="12"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container
              v-else-if="activeStep === 4"
              fluid
            >
              <v-form v-model="sintesisForm">
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="ise.sintesisTecnica"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Síntesis técnica"
                      no-resize
                      rows="12"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container
              v-else-if="activeStep === 5"
              fluid
            >
              <v-form v-model="resultadoForm">
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="ise.observaciones"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Datos relevantes"
                      no-resize
                      rows="8"
                    />
                    <v-select
                      v-model="ise.fk_idCatDiagnostico"
                      label="Diagnóstico preliminar"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="diagnostico"
                      item-value="id"
                      item-text="title"
                      :rules="nameRules"
                    />
                    <v-select
                      v-model="ise.fk_idCatNumeral"
                      label="Numerales"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="numerales"
                      item-value="id"
                      item-text="title"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="ise.fk_idCatSemaforoResultado"
                      label="Semáforo de resultado"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="semaforoResultado"
                      item-value="id"
                      item-text="nombre"
                      item-color="secondary"
                      :rules="required"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container>
              <v-row>
                <v-col
                  md="12"
                  align="center"
                >
                  <v-btn
                    rounded
                    class="mx-8"
                    elevation="8"
                    color="secondary"
                    :loading="loading"
                    :disabled="!validActiveStep || loading"
                    @click="activeStepButtonHandler"
                  >
                    {{ activeStepButtonLabel }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-overlay
      :value="overlay"
      :z-index="999"
      align="center"
      color="secondary"
      opacity="1"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="text-overline mt-4">
        Cargando información. Por favor, espere...
      </div>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { circularProgressProps } from '../../components/props/props';
import EvaluadoInfoCardComponent from '../../components/EvaluadoInfoCardComponent.vue';

export default {
  components: {
    EvaluadoInfoCardComponent,
  },

  props: {
    idExpediente: {
      type: Number,
      required: true,
    },
    idProgramacion: {
      type: Number,
      required: true,
    },
    idDerivacion: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      circularProgressProps,

      loading: false,
      evaluadorForm: false,
      funcionesForm: false,
      analisisForm: false,
      sintesisForm: false,
      resultadoForm: false,
      overlay: false,

      activeStep: 1,

      ise: {
        fk_idExpediente: this.idExpediente,
        fk_idProgramacion: this.idProgramacion,
        fk_idDerivacion: this.idDerivacion,
        funciones: '',
        analisis: '',
        fk_idCatDiagnostico: null,
        sintesisTecnica: '',
        observaciones: '',
        fk_idEvaluador: null,
        fk_idCatEstatusEvaluacion: 1,
        fk_idSupervisor: null,
        fk_idCatNumeral: null,
        fk_idCatSemaforoResultado: null,
      },

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('expediente', {
      expediente: 'getExpedientesPersonal',
    }),

    ...mapGetters('diagnostico', {
      diagnostico: 'getDiagnostico',
    }),
    ...mapGetters('evaluadores', {
      evaluadores: 'getEvaluadores',
    }),
    ...mapGetters('numerales', {
      numerales: 'getNumerales',
    }),
    ...mapGetters('estatusEvaluacion', {
      estatusEvaluacion: 'getEstatusEvaluacion',
    }),

    ...mapGetters('semaforoResultado', {
      semaforoResultado: 'getSemaforoResultado',
    }),

    activeStepTitle() {
      switch (this.activeStep) {
        case 1:
          return 'Evaluador y supervisor';
        case 2:
          return 'Funciones';
        case 3:
          return 'Análisis';
        case 4:
          return 'Síntesis técnica';
        case 5:
          return 'Resultados';
        default:
          return '';
      }
    },

    validActiveStep() {
      switch (this.activeStep) {
        case 1:
          if (this.evaluadorForm) {
            return true;
          } return false;
        case 2:
          return true;
        case 3:
          return true;
        case 4:
          return true;
        case 5:
          if (this.resultadoForm) {
            return true;
          } return false;
        default:
          return false;
      }
    },

    activeStepButtonLabel() {
      if (this.activeStep < 5) {
        return 'Siguiente paso';
      }
      return 'Registrar diagnóstico';
    },
  },

  async mounted() {
    this.overlay = true;
    await this.fetchExpedienteById(this.idExpediente);
    this.overlay = false;
  },

  methods: {
    ...mapActions('evaluacionesISE', ['saveEvaluacionIse']),
    ...mapActions('expediente', ['fetchExpedienteById']),
    ...mapActions('derivaciones', ['updateDerivacion', 'updateEstatusDerivacion', 'fetchDerivacionesByArea']),

    async activeStepButtonHandler() {
      if (this.activeStep < 5) {
        this.activeStep += 1;
      } else {
        this.loading = true;

        await this.saveEvaluacionIse(this.ise);

        await this.fetchDerivacionesByArea(20);

        this.loading = false;
        this.$router.push('/investigacion_socioeconomica/ise');
      }
    },
  },
};
</script>
